import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
  onOpenEditModal: () => void
}

const Footer = ({ onClose, onOpenEditModal }: Props) => {
  const onClickEdit = () => {
    onClose()
    onOpenEditModal()
  }
  return (
    <>
      <Button type="secondary" onClick={onClose}>
        {i18n.t('common.close')}
      </Button>
      <Button type="primary" onClick={onClickEdit}>
        {i18n.t('common.edit')}
      </Button>
    </>
  )
}

export default observer(Footer)
